import React from 'react';
import uuid from 'uuid';
import CompanySelector from '../CompanySelector/';
import Form from '../../../../../../../../components/Form/Form/';

class ExperienceInput extends React.Component {
  constructor(props, context) {
    super(props, context);

    let ExistingCompanies = {};

    if (typeof props.InitialData === 'object' && props.InitialData !== null) {
      for (let index = 0; index < props.InitialData.length; index++) {
        let TimeBreakDowns = {};

        if (props.InitialData[index].StartDate !== null) { // Given in format 2016-03-15
          TimeBreakDowns['StartYear'] = props.InitialData[index].StartDate.slice(0, 4);
          TimeBreakDowns['StartMonth'] = props.InitialData[index].StartDate.slice(5, 7);
        }

        if (props.InitialData[index].EndDate !== null) { // Given in format 2016-03-15
          TimeBreakDowns['EndYear'] = props.InitialData[index].EndDate.slice(0, 4);
          TimeBreakDowns['EndMonth'] = props.InitialData[index].EndDate.slice(5, 7);
        }

        ExistingCompanies = { // Convert Database Format to format used by form
          ...ExistingCompanies,
          [(uuid.v4())]: {
            ...props.InitialData[index],
            ...TimeBreakDowns,
          }
        };
      }
    }

    this.state = {
      Companies: ExistingCompanies,
    };

    this.handleSubFormChange = this.handleSubFormChange.bind(this);
    this.incrementCount = this.incrementCount.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.emitOnChange = this.emitOnChange.bind(this);
  }

  handleSubFormChange(Key) {
    return event => {
      const NewCompanies = {
        ...this.state.Companies,
        [Key]: event.target.value,
      };

      this.setState({
        Companies: NewCompanies,
      });
      this.emitOnChange(NewCompanies);
    }
  }

  handleRemove(NeedleKey) {
    return event => {
      const NewCompanies = Object.keys(this.state.Companies) // Form new Companies object
        .filter(key => key !== NeedleKey)
        .reduce((res, key) => (res[key] = this.state.Companies[key], res), {});

      this.setState({
        Companies: NewCompanies,
      })

      this.emitOnChange(NewCompanies);
    }
  }

  handleSortChange(Key) {
    return Direction => () => {
      let ExperienceOrder = Object.keys(this.state.Companies);
      ExperienceOrder.sort((a, b) => { // Zero is top of list
        return this.state.Companies[a].SortOrder - this.state.Companies[b].SortOrder;
      });

      const CurrentIndex = ExperienceOrder.findIndex(x => x === Key);
      let NewOrder = [];

      for (let i = 0; i < ExperienceOrder.length; i++) { // Reorder
        if (Direction < 0) { // Up
          if (i === CurrentIndex + Direction) {
            NewOrder.push(ExperienceOrder[CurrentIndex])
          }
        }

        if (i !== CurrentIndex) {
          NewOrder.push(ExperienceOrder[i])
        }

        if (Direction > 0) { // Down
          if (i === CurrentIndex + Direction) {
            NewOrder.push(ExperienceOrder[CurrentIndex])
          }
        }
      }


      let NewCompanies = this.state.Companies;

      for (let j = 0; j < NewOrder.length; j++) { // Set Order for all
        NewCompanies[NewOrder[j]].SortOrder = j;
      }

      this.setState({
        Companies: NewCompanies,
      });
      this.emitOnChange(NewCompanies);
    };
  }

  incrementCount() {
    this.setState({
      Companies: {
        ...this.state.Companies,
        [(uuid.v4())]: {
          SortOrder: Object.keys(this.state.Companies),
        },
      }
    })
  }

  emitOnChange(NewCompanies) {
    if (this.props.onChange) {
      const ReturnObject = Object.keys(NewCompanies).map(Key => {
        const ExperienceEntry = NewCompanies[Key];

        let StartDate = {};
        let EndDate = {};

        if (Object.prototype.hasOwnProperty.call(ExperienceEntry, 'StartYear')) {
          if (Object.prototype.hasOwnProperty.call(ExperienceEntry, 'StartMonth')) {
            StartDate = {
              start_date: ExperienceEntry['StartYear'] + "-" + ExperienceEntry['StartMonth'] + "-01"
            }
          } else {
            StartDate = {
              start_date: ExperienceEntry['StartYear'] + "-01-01"
            }
          }
        }

        if (Object.prototype.hasOwnProperty.call(ExperienceEntry, 'EndYear')) {
          if (Object.prototype.hasOwnProperty.call(ExperienceEntry, 'EndMonth')) {
            EndDate = {
              end_date: ExperienceEntry['EndYear'] + "-" + ExperienceEntry['EndMonth'] + "-01"
            }
          } else {
            EndDate = {
              end_date: ExperienceEntry['EndYear'] + "-01-01"
            }
          }
        }

        return {
          ...StartDate,
          ...EndDate,
          ...((typeof ExperienceEntry.company === 'object' && ExperienceEntry.company !== null) ? {
            "company_name": ExperienceEntry.company.name,
          } : {}),
          "job_position_name": ExperienceEntry.JobTitle || "",
          "sort_order": String(ExperienceEntry.SortOrder)
        };
      });

      this.props.onChange({
        target: {
          value: ReturnObject,
        },
      });
    }
  }

  renderFormEntry(UniqueKey, Index) {
    // Index is a zero index for the element from the top of the list
    const ExperienceData = this.state.Companies[UniqueKey];

    return (
      <div className='ExperienceInput' key={UniqueKey}>
        <Form defaultValue={ExperienceData} onChange={this.handleSubFormChange(UniqueKey)}>
          <div className='row'>
            <div className='ProfileExperence__SortWrapper'>
              {(Index > 0) ? (
                <a onClick={this.handleSortChange(UniqueKey)(-1)} className='ProfileExperence__UpButton'><span>&#9650;</span> Move Up</a>
              ) : null}
              {(Index !== (Object.keys(this.state.Companies).length - 1)) ? (
                <a onClick={this.handleSortChange(UniqueKey)(1)} className='ProfileExperence__DownButton'><span>&#9660;</span> Move Down</a>
              ) : null}
            </div>
            <a onClick={this.handleRemove(UniqueKey)} className='ProfileExperience__RemoveButton'><b>×</b> Remove</a>
            <input type='hidden' name='UserPositionID' />
            <div className='col'>
              <div className='Form__inputWrap'>
                <label htmlFor='Form__CompanyName' className='Form__InputLabel'>Company Name*</label>
                <CompanySelector name='company' className='Form__Input Form__Input--white' />
              </div>
            </div>
            <div className='col'>
              <div className='Form__inputWrap'>
                <label htmlFor='Form__JobTitle' className='Form__InputLabel'>Job Title*</label>
                <input id='Form__JobTitle' type='text' name='JobTitle' className='Form__Input Form__Input--white' />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm'>
              <div className='Form__inputWrap'>
                <label className='Form__InputLabel'>Start Date* </label>
                <div className='row'>
                  <div className='col'>
                    <select className='Form__Input Form__Input--white' name='StartYear' required>
                      <option>Year</option>
                      <option value='2018'>2018</option>
                      <option value='2017'>2017</option>
                      <option value='2016'>2016</option>
                      <option value='2015'>2015</option>
                      <option value='2014'>2014</option>
                      <option value='2013'>2013</option>
                      <option value='2012'>2012</option>
                      <option value='2011'>2011</option>
                      <option value='2010'>2010</option>
                      <option value='2009'>2009</option>
                      <option value='2008'>2008</option>
                      <option value='2007'>2007</option>
                      <option value='2006'>2006</option>
                      <option value='2005'>2005</option>
                      <option value='2004'>2004</option>
                      <option value='2003'>2003</option>
                      <option value='2002'>2002</option>
                      <option value='2001'>2001</option>
                      <option value='2000'>2000</option>
                      <option value='1999'>1999</option>
                      <option value='1998'>1998</option>
                      <option value='1997'>1997</option>
                      <option value='1996'>1996</option>
                    </select>
                  </div>
                  <div className='col'>
                    <select className='Form__Input Form__Input--white' name='StartMonth' required>
                      <option>Month</option>
                      <option value='01'>Jan</option>
                      <option value='02'>Feb</option>
                      <option value='03'>Mar</option>
                      <option value='04'>Apr</option>
                      <option value='05'>May</option>
                      <option value='06'>Jun</option>
                      <option value='07'>Jul</option>
                      <option value='08'>Aug</option>
                      <option value='09'>Sep</option>
                      <option value='10'>Oct</option>
                      <option value='11'>Nov</option>
                      <option value='12'>Dec</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-sm'>
              <div className='Form__inputWrap'>
                <label className='Form__InputLabel'>End Date, unless current</label>
                <div className='row'>
                  <div className='col'>
                    <select className='Form__Input Form__Input--white' name='EndYear'>
                      <option>Year</option>
                      <option value='2018'>2018</option>
                      <option value='2017'>2017</option>
                      <option value='2016'>2016</option>
                      <option value='2015'>2015</option>
                      <option value='2014'>2014</option>
                      <option value='2013'>2013</option>
                      <option value='2012'>2012</option>
                      <option value='2011'>2011</option>
                      <option value='2010'>2010</option>
                      <option value='2009'>2009</option>
                      <option value='2008'>2008</option>
                      <option value='2007'>2007</option>
                      <option value='2006'>2006</option>
                      <option value='2005'>2005</option>
                      <option value='2004'>2004</option>
                      <option value='2003'>2003</option>
                      <option value='2002'>2002</option>
                      <option value='2001'>2001</option>
                      <option value='2000'>2000</option>
                      <option value='1999'>1999</option>
                      <option value='1998'>1998</option>
                      <option value='1997'>1997</option>
                      <option value='1996'>1996</option>
                    </select>
                  </div>
                  <div className='col'>
                    <select className='Form__Input Form__Input--white' name='EndMonth'>
                      <option>Month</option>
                      <option value='01'>Jan</option>
                      <option value='02'>Feb</option>
                      <option value='03'>Mar</option>
                      <option value='04'>Apr</option>
                      <option value='05'>May</option>
                      <option value='06'>Jun</option>
                      <option value='07'>Jul</option>
                      <option value='08'>Aug</option>
                      <option value='09'>Sep</option>
                      <option value='10'>Oct</option>
                      <option value='11'>Nov</option>
                      <option value='12'>Dec</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    )
  }

  render() {
    let ExperienceOrder = Object.keys(this.state.Companies);
    ExperienceOrder.sort((a, b) => { // Zero is top of list
      return this.state.Companies[a].SortOrder - this.state.Companies[b].SortOrder;
    });

    return (
      <div>
        {ExperienceOrder.map((Key, Index) => this.renderFormEntry(Key, Index))}
        <a className='Experience__AddButton' onClick={this.incrementCount}>+ Add Experience</a>
      </div>
    );
  }
};


export default ExperienceInput;


// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Experience/components/ExperienceInput/index.js